export class Discussion {
    static toggleEditMode(btn) {
        const card = btn.closest('.card');
        card.querySelectorAll('.edit-mode,.view-mode').forEach(el => el.classList.toggle('is-hidden'));
        btn.classList.toggle('is-active');
    }

    static vote(btn, post_id, direction) {
        axios.post(`/action/discussion_post/${post_id}/vote`, {"direction": direction}).then((response) => {
            const btn_up = btn.closest('.card').querySelector('.btn-upvote')
            const btn_down = btn.closest('.card').querySelector('.btn-downvote')
            if (response.data.my_upvote) {
                btn_up.classList.add('is-info')
            } else {
                btn_up.classList.remove('is-info')
            }
            if (response.data.my_downvote) {
                btn_down.classList.add('is-danger')
            } else {
                btn_down.classList.remove('is-danger')
            }
            btn_up.querySelector("span:nth-child(2)").innerText = response.data.upvotes
            btn_down.querySelector("span:nth-child(2)").innerText = response.data.downvotes
        })
    }

    static deletePost(btn, post_id) {
        if (! confirm("Are you sure you want to delete this post?")) {
            return
        }
        axios.post(`/action/discussion_post/${post_id}/delete`, {}).then(response => {
            const card = btn.closest('.card')
            card.querySelector('.view-mode').innerHTML = "<i class='has-text-danger'>This post was deleted.</i>"
            card.querySelectorAll('.drop-on-delete').forEach(el => el.remove())
            card.querySelectorAll('.btn-upvote, .btn-downvote').forEach(el => el.disabled = true)
        })
    }

    static toggleReply(btn) {
        btn.closest('.card').querySelector('.add-comment').classList.toggle('is-hidden');
        btn.classList.toggle('is-active');
    }
}